import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import Component from './components/GifNodeView';
import { cleanLinkSrc } from '../../components/Viewer/useHandlers';
import { EXTENSION_TYPE_NAME } from './constants';
import { deleteExtension } from '../../components/utils/tiptap';
export var MenuState = /*#__PURE__*/ function(MenuState) {
    MenuState[MenuState["HIDDEN"] = 0] = "HIDDEN";
    MenuState[MenuState["SHOW"] = 1] = "SHOW";
    return MenuState;
}({});
export const Gif = Node.create({
    name: 'da-gif',
    group: 'block unlinkable',
    inline: false,
    draggable: true,
    addStorage () {
        return {
            menuState: 0
        };
    },
    addOptions () {
        return {
            HTMLAttributes: {},
            defaultWidth: 780,
            smallMedia: false,
            canAlign: true
        };
    },
    addAttributes () {
        var _this_options_defaultAlignment;
        return {
            url: {
                default: null
            },
            width: {
                default: null
            },
            height: {
                default: null
            },
            alignment: {
                default: (_this_options_defaultAlignment = this.options.defaultAlignment) !== null && _this_options_defaultAlignment !== void 0 ? _this_options_defaultAlignment : 'center'
            }
        };
    },
    /**
   * Used to parse incoming html, usually via paste
   */ parseHTML () {
        return [
            {
                tag: `div[data-da-type="${EXTENSION_TYPE_NAME}"]`,
                getAttrs (node) {
                    if (!node || !node.getAttribute) {
                        return false;
                    }
                    const dataType = node.getAttribute('data-da-type');
                    if (!dataType || dataType !== EXTENSION_TYPE_NAME) {
                        return false;
                    }
                    try {
                        var _node_getAttribute, _node_getAttribute1, _node_getAttribute2, _node_getAttribute3;
                        return {
                            alignment: (_node_getAttribute = node.getAttribute('data-alignment')) !== null && _node_getAttribute !== void 0 ? _node_getAttribute : undefined,
                            width: (_node_getAttribute1 = node.getAttribute('data-width')) !== null && _node_getAttribute1 !== void 0 ? _node_getAttribute1 : undefined,
                            height: (_node_getAttribute2 = node.getAttribute('data-height')) !== null && _node_getAttribute2 !== void 0 ? _node_getAttribute2 : undefined,
                            url: (_node_getAttribute3 = node.getAttribute('data-url')) !== null && _node_getAttribute3 !== void 0 ? _node_getAttribute3 : undefined
                        };
                    } catch (e) {}
                    return null;
                }
            }
        ];
    },
    renderHTML (props) {
        const { HTMLAttributes: { url, width, height } } = props, rest = _object_without_properties(props.HTMLAttributes, [
            "url",
            "width",
            "height"
        ]);
        return [
            'video',
            mergeAttributes({
                autoplay: true,
                loop: true,
                muted: true,
                'data-da-type': EXTENSION_TYPE_NAME,
                'data-width': width,
                'data-height': height,
                width,
                playsInline: true,
                controlsList: 'nofullscreen',
                height
            }, rest),
            [
                'source',
                {
                    src: cleanLinkSrc(url, [
                        'giphy.com'
                    ])
                }
            ]
        ];
    },
    addNodeView () {
        return ReactNodeViewRenderer(Component);
    },
    onSelectionUpdate () {
        if (this.editor.isActive('da-gif')) {
            this.editor.commands.daGifOpenSettingsMenu();
        } else {
            this.editor.commands.daGifCloseSettingsMenu();
        }
    },
    addCommands () {
        return {
            daGifAddGif: (gif)=>({ commands })=>{
                    this.storage.menuState = 1;
                    return commands.insertContent({
                        type: this.name,
                        attrs: _object_spread({}, gif)
                    });
                },
            daGifOpenSettingsMenu: ()=>({ editor, chain, dispatch })=>{
                    if (dispatch) {
                        this.storage.menuState = 1;
                    }
                    return true;
                },
            daGifCloseSettingsMenu: ()=>({ editor, chain, dispatch })=>{
                    if (dispatch) {
                        this.storage.menuState = 0;
                    }
                    return true;
                },
            daGifAlign: (alignment)=>({ editor, chain, dispatch, commands })=>{
                    if (!this.options.canAlign) {
                        return false;
                    }
                    if (dispatch) {
                        return commands.updateAttributes(this.name, {
                            alignment
                        });
                    }
                    return true;
                },
            daGifDelete: ()=>({ editor, chain, dispatch, commands, state })=>{
                    if (deleteExtension(EXTENSION_TYPE_NAME, editor, dispatch, state)) {
                        this.storage.menuState = 0;
                        return true;
                    }
                    return true;
                },
            daGifReplace: (gif)=>({ editor, chain, dispatch, commands, state })=>{
                    if (dispatch) {
                        commands.updateAttributes(this.name, _object_spread({}, gif));
                        return true;
                    }
                    return true;
                }
        };
    }
});

//# sourceMappingURL=gif.js.map